import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import amoea_logo from 'images/moea-logo.webp';
import '~/font.css';

class App extends Component {
  componentDidMount () {
    this.props.getSystemCount();
  }

  render () {
    const { children = null, count = 0, isManage } = this.props;
    return (
      <div style={{
        position: 'absolute',
        top: '43.47%',
        left: '50%',
        transform: 'translate( -50%,-43.47%)',
      }}
      >
        <div style={{ width: 451, height: 455, backgroundColor: 'white', borderRadius: 50, display: 'flex', flexDirection: 'column' }}>
          <div style={{ paddingTop: 46, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img style={{ width: 57, height: 39, pointerEvents: 'none' }} src={amoea_logo} alt='' />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
              {/* {isManage && <div className='Arial_Black' style={{ paddingLeft: 16, fontSize: 20, letterSpacing: 0.05, fontFamily: 'sans-serif', fontWeight: 900 }}>離岸風力發電設置案件</div>}
              {isManage && <div className='Arial_Black' style={{ paddingLeft: 16, fontSize: 20, letterSpacing: 0.05, fontFamily: 'sans-serif', fontWeight: 900 }}>工作進度資訊管考平台</div>}
              {!isManage && <div className='Arial_Black' style={{ paddingLeft: 16, fontSize: 20, letterSpacing: 0.05, fontFamily: 'sans-serif', fontWeight: 900 }}>離岸風場海洋生態</div>}
              {!isManage && <div className='Arial_Black' style={{ paddingLeft: 16, fontSize: 20, letterSpacing: 0.05, fontFamily: 'sans-serif', fontWeight: 900 }}>調查資訊平台</div>} */}
              <div className='Arial_Black' style={{ paddingLeft: 16, fontSize: 20, letterSpacing: 0.05, fontFamily: 'sans-serif', fontWeight: 900 }}>離岸風力發電設置案件</div>
              <div className='Arial_Black' style={{ paddingLeft: 16, fontSize: 20, letterSpacing: 0.05, fontFamily: 'sans-serif', fontWeight: 900 }}>工作進度資訊管考平台</div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>{children}</div>
        </div>
        <div style={{ paddingTop: 8, color: 'white', fontSize: 16, lineHeight: '24px', letterSpacing: 0.05 }}>{`網站瀏覽人次：${count}`}</div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  count: state.data.SystemCount,
  isManage: state.isManage,
});
const mapDispatchToProps = dispatch => ({
  getSystemCount: () => Actions.getSystemCount(dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(App);
